import {useEffect, useState} from "react";
import {Badge} from "reactstrap";
import {getListReferralTransaction} from "@store/actions/withdrawal";
import {useDispatch, useSelector} from "react-redux";
import alert from "@src/utility/Alert";
import AtomPageLoader from "@atoms/PageLoader";
import OrganismDatatable from "@organism/datatable";
import moment from "moment";

const WithdrawalHistory = ({stepper, loadSection, id}) => {
    const dispatch = useDispatch();
    const {
        transactions
    } = useSelector((state) => state.withdrawal);
    const [isFetch, setIsFetch] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            if(id === loadSection) {
                try {
                    setIsFetch(false);
                    setLoading(true);
                    await dispatch(getListReferralTransaction());
                } catch (error) {
                    alert.error(error.message);
                } finally {
                    setLoading(false);
                    setIsFetch(true);
                }

            }
        })();
    }, [loadSection]);

    const columns = [
        {
            name: 'Tanggal',
            selector: ({created_at}) => (
                moment().format("MMMM Do YYYY, h:mm:ss a")
            ),
            sortable: true,
        },
        {
            name: 'Name',
            selector: 'name',
            sortable: true,
        },
        {
            name: 'Invoice',
            selector: 'sid_invoice',
            sortable: true,
        },
        {
            name: 'Fee',
            selector: 'fee',
            sortable: true,
        },
    ]
    return (
        <>
            <Badge color="primary" className={"mb-2"}>Data Referral</Badge>
            {loading ? <AtomPageLoader/> :
            <>
                <OrganismDatatable
                    tableData={transactions}
                    columns={columns} />
            </>
            }
        </>
    )
}

export default WithdrawalHistory